import React from 'react'
import { Menu } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { translate } from 'loankeeper-common/helpers'
import { LKIcon } from 'loankeeper-common/components'

import { colors } from 'shared'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'

import { actions as DetailsContainerActions, constants as DCConstants } from '../../../DetailsContainer'
import Modals, { openAddLoanPermissionsModal, openDeleteLoanPermissionModal } from './Modals'

import { OtherTabsProps } from '../../types.LoanDetails'

const LKGridConfig = {
  gridIdentity: {
    formName: 'frm_sec_RL',
    objectName: 'dbgrd_all',
  },

  syncGridState: true,
  enableRowSelection: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,

  getRowStyle: ({
    node: {
      data: { AGen },
    },
  }) => {
    if (AGen !== 0) {
      return { color: colors.grey }
    }

    return {}
  },
}

@withRouter
@withConstantPermissions(['ADD_RL as CanAdd', 'DEL_RL as CanDelete'])
//@ts-ignore
@connect(
  undefined,
  (
    dispatch,
    {
      match: {
        params: { ID, hash },
      },
    },
  ) => ({
    openAddPermissionModal: () => dispatch(openAddLoanPermissionsModal()),
    openDeletePermissionModal: (permissionID: number) =>
      dispatch(openDeleteLoanPermissionModal(permissionID, ID, hash)),
    reloadPermissions: () =>
      dispatch(
        DetailsContainerActions.fetchPage({
          type: 'Loan',
          ID,
          hash,
          page: 'accessperms',
        }),
      ),
  }),
)
class LoanExtras extends React.PureComponent<OtherTabsProps> {
  static defaultProps = {
    data: [],
  }

  getContextMenu = ({
    node: {
      data: { AGen, SEC_UserID },
    },
  }) => {
    const result = []

    if (this.props.CanDelete) {
      result.push({
        name: translate('frm_sec_RL-cmd_delete'),
        icon: 'delete',
        disabled: AGen !== 0,
        action: () => this.props.openDeletePermissionModal(SEC_UserID),
      })
    }

    return result
  }

  render() {
    const { data, ID, CanAdd } = this.props

    return (
      <div className="u-flex u-fluid u-directionColumn u-padding-5">
        <Menu attached="top">
          <Menu.Item className="u-noPadding u-paddingRight-15 u-paddingLeft-5">
            <LKIcon alias="key" style={{ marginRight: 5 }} />
            {translate('frm_sec_RL-frm_sec_RL')}
          </Menu.Item>
        </Menu>

        <div className="u-fluid u-relative">
          <LKGrid
            instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-AccessPermissions`}
            rowData={data}
            getContextMenuItems={this.getContextMenu}
            {...LKGridConfig}
          />
        </div>

        <div className="u-padding-5">
          {CanAdd && (
            <LKButton alias="add" onClick={this.props.openAddPermissionModal}>
              {translate('frm_sec_RL-cmd_add')}
            </LKButton>
          )}
        </div>

        <Modals permissions={data} onRefresh={this.props.reloadPermissions} />
      </div>
    )
  }
}

export default LoanExtras
